import { render, staticRenderFns } from "./RadioButtonCard.vue?vue&type=template&id=223e9676&scoped=true"
import script from "./RadioButtonCard.vue?vue&type=script&lang=js"
export * from "./RadioButtonCard.vue?vue&type=script&lang=js"
import style0 from "./RadioButtonCard.vue?vue&type=style&index=0&id=223e9676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223e9676",
  null
  
)

export default component.exports